import {useRef, useEffect} from 'react';
import {Box} from '@mui/material';
import CopyToClipboardButton from './CopyToClipboardButton';

const TrackNameCell = ({value}: {value: string}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = value;
    }
  }, [value]);

  return (
    <Box display='flex' alignItems='center'>
      <input
        ref={inputRef}
        type='text'
        value={value}
        readOnly
        style={{display: 'none'}}
      />
      <span>{value}</span>
      <CopyToClipboardButton inputRef={inputRef} />
    </Box>
  );
};

export default TrackNameCell;
